import { ReactNode } from "react";

interface CardProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
  onMouseDown?: () => void;
  onMouseUp?: () => void;
  onMouseLeave?: () => void;
}

export function Card({
  children,
  className = "",
  onClick,
  onMouseDown,
  onMouseUp,
  onMouseLeave,
}: CardProps) {
  return (
    <div
      className={`rounded-lg ${className}`}
      onClick={onClick}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </div>
  );
}
